<template>
  <div class="EventsDataTable-container Content clearfix">
    <div>
      <div
        class="Filter-container u-floatRight u-flex"
      >
        <div style="width: 250px;">
          <form-auto-complete
            v-model="model.filter"
            :items="dataTableFilters"
            :searchable="false"
            option-key="field"
            placeholder="Filter"
            @input="filterTable"
          />
        </div>
        <div class="SearchInputGroup">
          <rmp-input
            v-model="additionalParams.search"
            :clearable="true"
            input-type="text"
            placeholder="Search by Event or Theme name"
            @keypress.enter="submitSearch"
            @cleared="handleClearedSearch"
          />
        </div>
      </div>
      <div class="">
        <div
          v-if="loadingState"
          class="js-loading"
        />

        <place-holder
          v-if="ui.showPlaceHolder"
          :search="additionalParams.search"
          lang-key="events"
        />
        <div
          :class="['DataTable',{'DataTable--hide': ui.showPlaceHolder}]"
        >
          <vuetable-pagination-info
            ref="paginationInfo"
            :css="paginationInfoConfig.css"
            :info-template="table.paginationInfoConfig.infoTemplate"
          />
          <vue-table
            ref="vuetable"
            :api-mode="true"
            :api-url="table.options.apiUrl"
            :fields="table.options.columns"
            :append-params="additionalParams"
            :css="tableConfig.css"
            :per-page="tableConfig.perPage"
            :sort-order="table.options.sortOrder"
            pagination-path=""
            @vuetable:loading="loadingState = true"
            @vuetable:loaded="setTableStatus"
            @vuetable:load-error="handleDataTableError"
            @vuetable:pagination-data="onPaginationData"
          >
            <div
              slot="name"
              slot-scope="props"
              class="Name"
            >
              <p class="tempalte">
                {{ props.rowData.name }}
              </p>
            </div>
            <div
              slot="type"
              slot-scope="props"
            >
              <span
                v-if="props.rowData.type === 'dynamic'"
                class="Icon-s Icon-bolt"
                title="Dynamic"
              />
              <span
                v-else
                class="Icon-s Icon-clipboard-list"
                title="Static"
              />
            </div>
            <div
              slot="updated_at"
              slot-scope="props"
              class="Name"
            >
              <p class="template">
                {{ props.rowData.updated_at }}
              </p>
            </div>
            <div
              slot="theme_name"
              slot-scope="props"
              class="Name"
            >
              <p>
                {{ props.rowData.themeName }}
              </p>
            </div>
            <div
              slot="records"
              slot-scope="props"
              class="Name"
            >
              <p class="template">
                {{ props.rowData.records }}
                <span
                  v-if="props.rowData.has_validation_errors"
                  class="Error-warning"
                ><span class="Icon Icon-exclamation-circle" /> Errors</span>
              </p>
            </div>
            <div
              slot="is_visible"
              slot-scope="props"
              class="Name"
            >
              <p class="template">
                <tool-tip>
                  <span
                    slot="trigger"
                  >
                    <span
                      v-if="props.rowData.is_visible"
                      class="IsVisible"
                    />
                    <span
                      v-else
                      class="NotVisible"
                    />
                  </span>
                  <p
                    slot="tip"
                    style="width: 200px"
                  >
                    When turned on an event is able to capture records via a webform. When turned off the form will display
                    the form closed message.
                  </p>
                </tool-tip>
              </p>
            </div>
            <span
              slot="actions"
              slot-scope="props"
            >

              <tool-tip>
                <span
                  slot="trigger"
                  class="Table-action"
                >
                  <span
                    slot="trigger"
                    style="cursor: pointer"
                    class="Icon-s Icon-eye"
                    @click="handleViewEvent(props.rowData.id)"
                  />
                </span>
                <p slot="tip">View</p>
              </tool-tip>

              <tool-tip v-if="!props.rowData.is_locked">
                <span
                  slot="trigger"
                  class="Table-action"
                >
                  <span
                    slot="trigger"
                    style="cursor: pointer"
                    class="Icon-s Icon-pencil"
                    @click="handleEditEvent(props.rowData)"
                  />
                </span>
                <p
                  slot="tip"
                >Edit your event basic info, questions, messages and automations.</p>
              </tool-tip>
              <tool-tip v-else>
                <span
                  slot="trigger"
                  class="Table-action"
                >
                  <span
                    class="Icon-s Icon-lock"
                  />
                </span>
                <p
                  slot="tip"
                >The event is locked because there are records being re-processed.</p>
              </tool-tip>
              <tool-tip
                class="Tooltip-actions-menu"
                is-clickable
              >
                <span
                  slot="trigger"
                  class="Icon-s Icon-ellipsis-h"
                  style="cursor: pointer"
                />
                <template #tip>
                  <ul class="ActionsMenu">
                    <li
                      v-if="props.rowData.embedded_code_generation_default_url !== null"
                      @click="handleShowEmbedModal(props.rowData)"
                    >Embed Event</li>
                    <li @click="handleShowDuplicateModal(props.rowData)">Duplicate Event</li>
                    <li @click="handleShowDeleteModal(props.rowData)">Delete Event</li>
                  </ul>
                </template>
              </tool-tip>

            </span>
          </vue-table>
          <span
            class="HelpButton"
            @click="ui.showEventsLegendModal = true"
          >
            Help?
          </span>
          <vuetable-pagination
            ref="pagination"
            class="u-floatRight"
            :css="paginationConfig.css"
            @vuetable-pagination:change-page="onChangePage"
          />
          <template v-if="selectedEvent">
            <embed-form-modal
              :key="selectedEvent.id"
              v-model="ui.showEmbedModal"
              :event="selectedEvent"
            />

            <duplicate-event-modal
              v-if="selectedEvent"
              :key="selectedEvent.name"
              v-model="ui.showDuplicateModal"
              :event="selectedEvent"
              @duplicate-event:success="handleCloseDuplicateModal"
            />
            <delete-event-modal
              v-model="ui.showDeleteModal"
              :event="selectedEvent"
              @delete-event:success="handleCloseDeleteModal"
            />
          </template>
          <events-help-modal v-model="ui.showEventsLegendModal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormAutoComplete from '@rmpenterprise/form-autocomplete-select';
import '@rmpenterprise/form-autocomplete-select/dist/autocomplete-select.esm.css';
import PlaceHolder from '../common/no-data-placeholder.vue';
import DataTableMixin from '../../../mixins/datatable-mixin';
import RmpTooltip from '../../common/tooltip.vue';
import DeleteEventModal from '../modals/delete-event';
import EmbedFormModal from '../modals/embed-form.vue';
import DuplicateEventModal from '../modals/duplicate-event.vue';
import EventsHelpModal from '../modals/events-help';

export default {
  components: {
    EventsHelpModal,
    'place-holder': PlaceHolder,
    'tool-tip': RmpTooltip,
    'form-auto-complete': FormAutoComplete,
    DeleteEventModal,
    EmbedFormModal,
    DuplicateEventModal,
  },
  mixins: [DataTableMixin],
  data() {
    return {
      loadingState: false,
      selectedEvent: null,
      ui: {
        hideFilters: false,
        loading: false,
        showEventsLegendModal: false,
        showEmbedModal: false,
        showDuplicateModal: false,
        showPlaceHolder: false,
        showDeleteModal: false,
      },
      model: {
        filter: null,
      },
      table: {
        paginationInfoConfig: {
          infoTemplate: '{from} - {to} of {total} Events',
          css: {
            infoClass: 'view-all',
          },
        },
        options: {
          sortOrder: [
            {
              field: 'start_date',
              direction: 'desc',
            },
          ],
          apiUrl: '/ajax/web-forms/events/list',
          columns: [
            {
              name: 'name',
              sortField: 'name',
              title: 'Name',
            },
            {
              name: 'type',
              title: 'Type',
            },
            {
              name: 'start_date',
              sortField: 'start_date',
              title: 'Event Date',
            },
            {
              name: 'themeName',
              sortField: 'themeName',
              title: 'Theme',
            },
            {
              name: 'records',
              sortField: 'records',
              title: 'Records',
            },
            {
              name: 'is_visible',
              sortField: 'is_visible',
              title: 'Visibilty',
            },
            { name: 'actions' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState('global', {
      dataTableFilters: (state) => state.dataTableFilters,
    }),
    ...mapState('events', {
      events: (state) => state.lists.events,
    }),
  },
  mounted() {
    this.getDataTableFilters('events');
  },
  methods: {
    ...mapActions('global', {
      getDataTableFilters: 'getDataTableFilters',
    }),
    ...mapActions('events', {
      getEvent: 'getEvent',
      deleteEvent: 'deleteEvent',
    }),
    handleClearedSearch() {
      this.submitSearch();
    },
    handleShowEmbedModal(event) {
      this.selectedEvent = event;
      this.ui.showEmbedModal = true;
    },
    handleShowDeleteModal(event) {
      this.selectedEvent = event;
      this.ui.showDeleteModal = true;
    },
    handleShowDuplicateModal(event) {
      this.selectedEvent = event;
      this.ui.showDuplicateModal = true;
    },
    routeRedirect(event, isEditable) {
      if (!isEditable) {
        event.preventDefault();
      }
    },
    handleCloseDuplicateModal() {
      this.$refs.vuetable.refresh();
    },
    handleCloseDeleteModal() {
      this.$refs.vuetable.refresh();
    },
    handleEditEvent(event) {
      if (event.type === 'dynamic') {
        this.$router.push({ name: 'basic-info-dynamic-form', params: { id: event.id } });
      } else {
        this.$router.push({ name: 'basic-info', params: { id: event.id } });
      }
    },
    handleViewEvent(eventId) {
      this.$router.push({ name: 'event-records', params: { eventId } });
    },
    filterTable() {
      // //  Filter  table
      this.$nextTick(() => {
        if (this.model.filter === null) {
          this.table.options.apiUrl = 'ajax/web-forms/events/list';
          return false;
        }
        //  Filter  table
        this.table.options.apiUrl = `ajax/web-forms/events/list?filter=${this.model.filter.value}`;
        return false;
      });
    },
  },
};
</script>

<style scoped lang="less">
// .Filter-container {
//   position: absolute;
//   right: 0;
//   top: -46px;
// }
.HelpButton {
  width: 100%;
  text-align: right;
  display: block;
  cursor: pointer;
}

.Icon-clipboard-list, .Icon-bolt {
  font-size: 16px;
}

.Name {
  p {
    margin: 0;
  }

  .list {
    color: #909090;
  }
}

.vuetable-pagination-info.right {
  margin-top: 10px;
  margin-right: 10px;
  float: left;
}

.Error-warning {
  color: red;
}

.IsVisible, .NotVisible {
  display: block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

.IsVisible {
  background: #39B546;
}

.NotVisible {
  background: grey;
}

.EventsTableLegend {
  li {
    padding: 3px;
  }
}

.SearchInputGroup {
  .Form-inputBox {
    width: 265px;
  }
}
</style>
